import { IProduct } from 'apis/algolia';
import { PretaxWalletStatus } from 'constants/accounts';
import { IEmployee } from 'hooks/useQueryProfile';

export const productIsEligibleForWallet = (
  product: IProduct,
  wallet: IEmployee['employee_wallets'][number]
): boolean => {
  if (
    !wallet.visible_to_employee ||
    wallet.status === PretaxWalletStatus.TERMINATED ||
    !wallet.company_wallet_configuration.active ||
    !wallet.company_wallet_configuration.is_twic_store_enabled ||
    wallet.company_wallet_configuration.blacklisted_vendors.includes(
      product.vendor_id
    )
  ) {
    return false;
  }

  const all_wallet_subcategories =
    wallet.company_wallet_configuration.categories
      .flatMap((category) => category.subcategories)
      .filter((subcat) => subcat.eligible)
      .map((subcat) => subcat.value);

  return product.subcategories.some((product_subcategory) =>
    all_wallet_subcategories.includes(product_subcategory)
  );
};

export const userIsInValidCountryForProduct = (
  product: IProduct,
  employee: IEmployee
): boolean => product.available_countries.includes(employee.settings.country);

const productIsActive = (product: IProduct): boolean =>
  product.is_vendor_active;

export const productIsEligibleForUser = (
  product: IProduct,
  employee: IEmployee
): boolean =>
  productIsActive(product) &&
  userIsInValidCountryForProduct(product, employee) &&
  employee.employee_wallets.some((wallet) =>
    productIsEligibleForWallet(product, wallet)
  );
